export { HttpError } from "./errors";
export { resolveBaseUrl } from "./adapters/services";

// Default singleton for application use
import { createHttpClient } from "./client";
export const httpClient = createHttpClient();
